import React from 'react';
import CustomButton from "../components/CustomButton";

const NotFoundPage = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-gray-800">
            <h1 className="text-6xl font-bold">404</h1>
            <p className="text-2xl mt-4">Página no encontrada...</p>
            <p className="mt-2 mb-4">Lo sentimos, la página que buscas no existe o todavía sigue en desarrollo.</p>
            <CustomButton
                text={'Ir a inicio'}
                onClick={() => window.location.href = '/'}
            />
        </div>
    );
};

export default NotFoundPage;